import { motion } from 'framer-motion';
import { ShieldCheck, ShieldAlert } from 'lucide-react';

export function VerifiedStamp({ valid = true, expired = false }) {
  if (!valid) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: [0.2, 0.8, 0.2, 1] }}
        data-testid="verify-not-verified-stamp"
        className="relative inline-flex items-center gap-3 rounded-full border border-[rgba(255,92,122,0.35)] bg-[rgba(255,92,122,0.10)] px-6 py-3 shadow-[0_0_0_1px_rgba(255,92,122,0.25),0_0_28px_rgba(255,92,122,0.18)]"
      >
        <ShieldAlert className="h-5 w-5 text-[#FF5C7A]" />
        <div className="text-left">
          <div className="font-display text-base font-bold tracking-wider text-[#FFD0DA]">NO VERIFICADO</div>
          <div className="text-[10px] uppercase tracking-widest text-[#FFD0DA]/80">Autenticidad no confirmada</div>
        </div>
      </motion.div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95, y: 6 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
      data-testid="verify-verified-stamp"
      className="relative inline-flex items-center gap-3 rounded-full border border-[rgba(85,117,245,0.35)] bg-[rgba(85,117,245,0.12)] px-6 py-3 shadow-[0_0_0_1px_rgba(85,117,245,0.25),0_0_28px_rgba(85,117,245,0.22)]"
    >
      <ShieldCheck className="h-5 w-5 text-[hsl(var(--primary))]" />
      <div className="text-left">
        <div className="font-display text-base font-bold tracking-wider text-foreground">
          {expired ? 'VERIFICADO · VENCIDO' : 'VERIFICADO'}
        </div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
          {expired ? 'Vigencia expirada' : 'Autenticidad confirmada'}
        </div>
      </div>
    </motion.div>
  );
}
